(() => {
  const roots = document.querySelectorAll('[data-pks-etb]');
  if (!roots.length) return;

  const routesRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const currency = window.Shopify?.currency?.active || 'AUD';
  const money = cents => new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(cents || 0) / 100);

  const animateNumber = (element, value) => {
    const text = money(value);
    element.classList.remove('is-animating');
    element.classList.add('t-digit-group');
    element.setAttribute('aria-label', text);
    element.replaceChildren();
    const characters = [...text];
    characters.forEach((character, index) => {
      const digit = document.createElement('span');
      digit.className = 't-digit';
      digit.textContent = character;
      if (index === characters.length - 2) digit.dataset.stagger = '1';
      if (index === characters.length - 1) digit.dataset.stagger = '2';
      element.appendChild(digit);
    });
    void element.offsetHeight;
    element.classList.add('is-animating');
  };

  roots.forEach(root => {
    const controls = root.querySelector('[data-pks-etb-form]');
    const quantityInput = root.querySelector('[data-pks-etb-quantity]');
    const totalTarget = root.querySelector('[data-pks-etb-total]');
    const compareTarget = root.querySelector('[data-pks-etb-compare]');
    const savingTarget = root.querySelector('[data-pks-etb-savings]');
    const buttonPrice = root.querySelector('[data-pks-etb-button-price]');
    const buttonTrailingPrice = root.querySelector('[data-pks-etb-button-trailing-price]');
    const submitButton = controls?.querySelector('[type="button"]');
    const status = root.querySelector('[data-pks-etb-status]');
    if (!controls || !submitButton || !totalTarget || !savingTarget) return;

    const refreshDispatchCountdown = () => {
      const countdown = root.querySelector('[data-pks-etb-dispatch-countdown]');
      const dispatchDay = root.querySelector('[data-pks-etb-dispatch-day]');
      if (!countdown || !dispatchDay) return;

      const parts = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Melbourne', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date()).reduce((result, part) => {
        if (part.type !== 'literal') result[part.type] = Number(part.value);
        return result;
      }, {});
      const now = new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      const cutoff = new Date(now);
      cutoff.setHours(14, 0, 0, 0);
      if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
      while (cutoff.getDay() === 0 || cutoff.getDay() === 6) cutoff.setDate(cutoff.getDate() + 1);

      const minutesLeft = Math.max(0, Math.ceil((cutoff.getTime() - now.getTime()) / 60000));
      const hours = Math.floor(minutesLeft / 60);
      const minutes = minutesLeft % 60;
      const dayDifference = Math.round((new Date(cutoff.getFullYear(), cutoff.getMonth(), cutoff.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
      const dayLabel = dayDifference === 0 ? 'today' : dayDifference === 1 ? 'tomorrow' : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][cutoff.getDay()];
      countdown.textContent = `${hours}h ${String(minutes).padStart(2, '0')}m`;
      dispatchDay.textContent = dayLabel;
    };
    refreshDispatchCountdown();
    window.setInterval(refreshDispatchCountdown, 60000);

    const currentTier = () => controls.querySelector('[data-pks-etb-tier]:checked');
    const selectedAddons = () => [...controls.querySelectorAll('[data-pks-etb-addon] input[type="checkbox"]:checked')];

    const updateTotals = animate => {
      const tier = currentTier();
      const quantity = Number(tier?.dataset.quantity || 1);
      let price = Number(tier?.dataset.price || controls.dataset.basePrice || 0);
      let compare = Number(tier?.dataset.compare || controls.dataset.baseCompare || price);
      selectedAddons().forEach(addon => {
        price += Number(addon.dataset.price || 0);
        compare += Number(addon.dataset.compare || addon.dataset.price || 0);
      });
      const saving = Math.max(0, compare - price);
      quantityInput.value = String(quantity);
      root.querySelectorAll('[data-pks-etb-tier-card]').forEach(card => {
        const radio = card.querySelector('[data-pks-etb-tier]');
        card.classList.toggle('is-selected', Boolean(radio?.checked));
      });
      if (animate) animateNumber(totalTarget, price);
      else {
        totalTarget.textContent = money(price);
        totalTarget.setAttribute('aria-label', money(price));
      }
      if (compareTarget) {
        compareTarget.textContent = money(compare);
        compareTarget.hidden = compare <= price;
      }
      if (animate) animateNumber(savingTarget, saving);
      else savingTarget.textContent = money(saving);
      if (buttonPrice) buttonPrice.textContent = money(price);
      if (buttonTrailingPrice) buttonTrailingPrice.textContent = money(price);
      root.dataset.quantity = String(quantity);
      root.dataset.total = String(price);
      root.dataset.saving = String(saving);
    };

    root.addEventListener('change', event => {
      if (event.target.matches('[data-pks-etb-tier], [data-pks-etb-addon] input[type="checkbox"]')) updateTotals(true);
    });
    updateTotals(false);

    submitButton.addEventListener('click', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitButton.disabled || submitButton.getAttribute('aria-busy') === 'true') return;
      const tier = currentTier();

      const quantity = Number(tier?.dataset.quantity || 1);
      const volumeCode = root.dataset.volumeDiscountCode || '';
      const addons = selectedAddons();
      const requestedCodes = [...new Set([
        quantity > 1 ? volumeCode : '',
        ...addons.map(addon => addon.dataset.discountCode || '')
      ].filter(Boolean))];
      const items = [{ id: Number(controls.querySelector('[data-pks-etb-variant]').value), quantity }];
      addons.forEach(addon => items.push({ id: Number(addon.dataset.variant), quantity: 1 }));

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.setAttribute('aria-label', 'Adding to cart');
      const productKind = root.dataset.productKind || 'product';
      status.textContent = `Adding ${quantity} ${productKind}${quantity === 1 ? '' : 's'} and ${addons.length} optional add-on${addons.length === 1 ? '' : 's'} to cart…`;
      status.removeAttribute('data-error');

      try {
        let codesToApply = requestedCodes;
        if (requestedCodes.length) {
          try {
            const cartResponse = await fetch(`${routesRoot}cart.js`, { credentials: 'same-origin' });
            const cartSnapshot = cartResponse.ok ? await cartResponse.json() : null;
            const existingCodes = (cartSnapshot.discount_codes || []).map(discount => String(discount.code || '').toUpperCase());
            const requestedUppercase = requestedCodes.map(code => code.toUpperCase());
            const hasOtherCode = existingCodes.some(code => code && !requestedUppercase.includes(code));
            codesToApply = hasOtherCode ? [] : requestedCodes.filter(code => !existingCodes.includes(code.toUpperCase()));
          } catch (_cartReadFailure) {
            codesToApply = requestedCodes;
          }
        }

        let returnTo = `${routesRoot}cart`;
        for (let index = codesToApply.length - 1; index >= 0; index -= 1) {
          returnTo = `${routesRoot}discount/${encodeURIComponent(codesToApply[index])}?redirect=${encodeURIComponent(returnTo)}`;
        }

        for (let index = items.length - 1; index >= 0; index -= 1) {
          const params = new URLSearchParams({
            id: String(items[index].id),
            quantity: String(items[index].quantity),
            return_to: returnTo
          });
          returnTo = `${routesRoot}cart/add?${params.toString()}`;
        }

        window.location.assign(returnTo);
      } catch (failure) {
        status.textContent = failure.message || 'This selection could not be added. Please try again.';
        status.dataset.error = 'true';
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.removeAttribute('aria-label');
      }
    }, { capture: true });
  });
})();
